/**
 * EmptyState Component
 *
 * Consistent empty state display with icon, title, description, and optional CTA.
 * Replaces repeated `p-12 text-center` empty state blocks.
 *
 * @component
 * @param {Object} props
 * @param {React.ElementType} [props.icon] - Lucide icon component
 * @param {string} [props.iconClassName] - Override icon classes (default: gray)
 * @param {string} props.title - Heading text
 * @param {string} [props.description] - Body text
 * @param {React.ReactNode} [props.action] - CTA element (button, link, etc.)
 */
import PropTypes from 'prop-types';
import Card from './Card';

export default function EmptyState({
  icon: Icon,
  iconClassName = 'w-16 h-16 text-gray-300 mx-auto mb-4',
  title,
  description,
  action,
}) {
  return (
    <Card padding="p-12" className="text-center">
      {Icon && <Icon className={iconClassName} />}
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
      {description && <p className="text-gray-600 mb-6">{description}</p>}
      {action}
    </Card>
  );
}

EmptyState.propTypes = {
  icon: PropTypes.elementType,
  iconClassName: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  action: PropTypes.node,
};
